










import Vue from "vue";
import Component from "vue-class-component";
import { Provide, Inject } from "vue-property-decorator";
import { ICellRendererParams } from "ag-grid-community";
import { IUserGridModel } from "../../models";
import { RestClient } from "@elite/restclient";
import UserManagementEvents from "./UserManagementEvents";

@Component
export default class UserManagementDeleteButton extends Vue {
    @Provide("params")
    params!: ICellRendererParams;

    @Inject()
    restClient!: RestClient;

    async deleteItem(item: IUserGridModel) {
        if (!confirm("Are you sure you want to delete this user?")) {
            return;
        }

        await this.restClient.delete(`/api/User/${item.id}`);

        this.$root.$emit(UserManagementEvents.gridRefreshEvent);
    }
}
